/**
 * Types in this file is specifically for Creating a Contact in ContactModal
 * If the type can be re-used for other pages, it should be in src/gql/interfaces
 */

/**
 * User information used to create a new user
 */
export interface UserInfo {
  userId: string;
  email: string;
  businessEntities: string[];
  givenName: string;
  familyName: string;
}

/**
 * User information used to create a new user while providing the corporation
 */
export interface VendorUserInfo extends UserInfo {
  corporation: string | null;
}

/**
 * Business entity information that is enough for UI rendering
 */
export interface UIBusinessEntity {
  id: string;
  name: string;
}

/**
 * Type for the hard-coded permission configuration that is used to render PermissionTable
 * @application used to render table header
 * @area optional, used to render table header
 * @permissions used to render table items
 */
export interface PermissionConfigProps {
  application: string;
  area?: string;
  permissions: UIPermission[];
}

export interface UIPermission {
  permissionId: string;
  name: string;
  actionClasses: string[];
  description: string;
}

/**
 * Permission action class will be used to render PermissionTable
 */

export interface PermissionActionClass {
  permissionId: string;
  actionClass: string;
}

/**
 * Guardian service constants
 */

export enum ActorTypes{
  USER = 'USER',
  GROUP = 'GROUP',
  UNKNOWN = 'UNKNOWN',
  USER_SPACE_SERVICE = 'USER_SPACE_SERVICE',
  PRODUCT_SPACE_SERVICE = 'PRODUCT_SPACE_SERVICE'
};

export const AssignGrantReasons = {
  Revoke: 'revoke',
  Assign: 'assign'
};

export const MLACActionClassTypes = {
  READ: 'READ',
  EDIT: 'EDIT',
  CREATE: 'CREATE',
  DELETE: 'DELETE'
};
